<script lang="ts">
    import {getLocalization} from 'src/core';
    import type {LoanRequestOption, Pickupability} from 'src/typings';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import KpPluralizeText from 'shared/components/kp-pluralize-text/KpPluralizeText.svelte';
    import BuildingsList from './shared/BuildingsList.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<Pickupability>;

    const localize = getLocalization();
</script>

<KpGenericPanel>
    <svelte:fragment slot="heading">
        <strong>{localize(/* @kp-localization loan.Vypujcit */ 'loan.Vypujcit')}</strong>
        <KpChipTag chipSize="sm" chipStyle="info">{localize(/* @kp-localization loan.Absencni */ 'loan.Absencni')}</KpChipTag>
    </svelte:fragment>

    <LoanOptionPanelBody>
        <div>
            {#if option.requestItems.length === 1}
                <KpPluralizeText count={option.capability.buildings.length}
                                 oneCountText={localize(/* @kp-localization loan.DokumentJeKVyzvednutiNaBudove */ 'loan.DokumentJeKVyzvednutiNaBudove')}
                                 moreText={localize(/* @kp-localization loan.DokumentJeKVyzvednutiNaBudovach */ 'loan.DokumentJeKVyzvednutiNaBudovach')}/>
            {:else if option.requestItems.length > 1}
                <KpPluralizeText count={option.capability.buildings.length}
                                 oneCountText={localize(/* @kp-localization loan.DokumentyJsouKVyzvednutiNaBudove */ 'loan.DokumentyJsouKVyzvednutiNaBudove')}
                                 moreText={localize(/* @kp-localization loan.DokumentyJsouKVyzvednutiNaBudovach */ 'loan.DokumentyJsouKVyzvednutiNaBudovach')}/>
            {/if}
        </div>

        <BuildingsList {option}/>
    </LoanOptionPanelBody>
</KpGenericPanel>